export const avatarOptions = {
  head: ['normal', 'wide', 'thin', 'none'],
  body: ['tShirt', 'golf', 'none'],
  hair: [
    'balndess',
    'slaughter',
    'ponyTail',
    'long',
    'curly',
    'stylish',
    'elvis',
    'classic02',
    'classic01',
    'none',
  ],
  mouth: ['default', 'missingTooth', 'none'],
  eyes: ['normal', 'confident', 'happy', 'none'],
  skinColor: ['yellow', 'white', 'dark', 'none'],
  hairColor: ['brown', 'black', 'red', 'none'],
  bodyColor: ['orange', 'blue', 'pink', 'none'],
  glassesProbability: [0, 100, 'none'],
  mustacheProbability: [0, 100, 'none'],
  blushesProbability: [0, 100, 'none'],
};

export const initialAvatarForm = {
  gender: 'none',
  head: 'none',
  body: 'none',
  hair: 'none',
  mouth: 'none',
  eyes: 'none',
  skinColor: 'none',
  hairColor: 'none',
  bodyColor: 'none',
  glassesProbability: 'none',
  mustacheProbability: 'none',
  blushesProbability: 'none',
};
